module.exports = __webpack_public_path__ + "static/media/bpmeasurex-charger-3.9248ab30.png";